import tmpl from './mine.phtml';
import View from 'lib/View';
import config from 'config';

export default View.extend({
	template: tmpl,

	// Affiche la page courante de visites avec contrôles de pagination
	render: function()
	{
		var page = this.page || 1;
		var total = this.total || 0;
		var pageSize = config.page_size;
		var pageCount = Math.max( 1, Math.ceil( total / pageSize ) );

		this.doRender({
			visit_list: this.collection.models,
			page: page,
			page_count: pageCount,
			total: total,
			page_size: pageSize,
			has_prev: page > 1,
			has_next: page < pageCount,
		});
	},
});
